import React, { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import Icon from "@/components/Icon";

export default function AuthCallback() {
  const location = useLocation();
  const nav = useNavigate();
  const { setUser } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const hash = location.hash || window.location.hash;
    const sid = new URLSearchParams(hash.replace("#", "")).get("session_id");
    if (!sid) { nav("/login"); return; }
    (async () => {
      try {
        const { data } = await api.post("/auth/session", {}, { headers: { "X-Session-ID": sid } });
        setUser(data);
        window.history.replaceState({}, "", "/app");
        nav("/app", { replace: true });
      } catch { nav("/login"); }
    })();
  }, [location, nav, setUser]);

  return <div className="min-h-screen grid place-items-center bg-background"><div className="text-center"><Icon name="Loader2" className="h-8 w-8 animate-spin text-primary mx-auto" /><p className="mt-3 text-sm text-muted-foreground">Signing you in...</p></div></div>;
}
